import client from './client';

export async function getReviewQueue(status = 'pending') {
  const { data } = await client.get('/email/review-queue/', { params: { status } });
  return data.data ?? data.results ?? [];
}

export async function getReviewQueueEntry(id) {
  const { data } = await client.get(`/email/review-queue/${id}/`);
  return data.data;
}

export async function actionReviewQueueEntry(id, action, notes = '') {
  const { data } = await client.post(`/email/review-queue/${id}/action/`, { action, notes });
  return data.data;
}

export async function getReviewQueueStats() {
  const { data } = await client.get('/email/review-queue/stats/');
  return data.data;
}

export async function pollInbox() {
  const { data } = await client.post('/email/poll/');
  return data.data;
}

export async function getTrainingNotes() {
  const { data } = await client.get('/email/training-notes/');
  return data.data ?? [];
}

export async function createTrainingNote(payload) {
  const { data } = await client.post('/email/training-notes/', payload);
  return data;
}

export async function updateTrainingNote(id, payload) {
  const { data } = await client.patch(`/email/training-notes/${id}/`, payload);
  return data;
}

export async function deleteTrainingNote(id) {
  await client.delete(`/email/training-notes/${id}/`);
}

export async function reprocessReviewEntry(id) {
  const { data } = await client.post(`/email/review-queue/${id}/reprocess/`);
  return data;
}

export async function getFullEmail(id) {
  const { data } = await client.get(`/email/review-queue/${id}/full-email/`);
  return data.data;
}

export async function chatWithEmail(id, message, history = []) {
  const { data } = await client.post(`/email/review-queue/${id}/chat/`, { message, history });
  return data.data;
}

export async function sendEmailResponse(id, subject, body, files = []) {
  // If attachments are present, use multipart/form-data so PDFs can be uploaded.
  // Otherwise fall back to JSON to preserve the existing fast path.
  if (files && files.length > 0) {
    const formData = new FormData();
    formData.append('subject', subject);
    formData.append('body', body);
    for (const f of files) {
      formData.append('files', f);
    }
    const { data } = await client.post(`/email/review-queue/${id}/send-response/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000, // attachments can be a few MB; allow more time than JSON path
    });
    return data.data;
  }
  const { data } = await client.post(`/email/review-queue/${id}/send-response/`, { subject, body });
  return data.data;
}

/**
 * Save a training note from the chat modal.
 * @param {string} id - Review queue entry ID
 * @param {string} vendorName - Vendor to apply note to (optional)
 * @param {string} senderPattern - Sender pattern to match (optional)
 * @param {string} noteText - The training instructions
 */
export async function saveTrainingNote(id, vendorName, senderPattern, noteText) {
  const { data } = await client.post(`/email/review-queue/${id}/save-training-note/`, {
    vendor_name: vendorName,
    sender_pattern: senderPattern,
    note_text: noteText,
  });
  return data.data;
}

/**
 * Prepare an email for reply - gets or creates a review queue entry.
 * Used when replying to vendor questions from the RFQ tab.
 * @param {string} emailMessageId - The EmailMessage UUID
 * @returns {Promise<{review_queue_id: string}>}
 */
export async function prepareEmailReply(emailMessageId) {
  const { data } = await client.post(`/email/${emailMessageId}/prepare-reply/`);
  return data.data;
}
